import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    caseid: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1
    },

    total: {
        width: '17.5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    poNumber: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    }
  });

  const PackageCaseHeader = () => (
    <View style={styles.container}>
        <Text style={styles.caseid}>Case ID</Text>
        <Text style={styles.description}>Description</Text>
        <Text style={styles.poNumber}>PO Number</Text>
        <Text style={styles.qty}>Qty</Text>
    </View>
  );

  export default PackageCaseHeader;
